import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const user = this.auth.getUser();
    const isExpired = this.auth.isTokenExpired();

    if (!user || isExpired) {
      if (user && isExpired) {
        this.auth.logout();
      }

      this.router.navigate(['/login'], {
        queryParams: { retUrl: state.url }
      });
      return false;
    }

    // proteção defensiva
    if (user.isAdmin !== true) {
      this.router.navigate(['/treino']);
      return false;
    }

    return true;
  }
}